import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51357fbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field col-6 md:col-12 md:max-w-20rem lg:max-w-20rem xl:max-w-20rem -ml-2 -mr-2 mb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "顧客名", -1))
const _hoisted_3 = { class: "formgroup-inline" }
const _hoisted_4 = { class: "field-radiobutton md:mr-1" }
const _hoisted_5 = {
  for: "customer-status-new",
  class: "ml-2"
}
const _hoisted_6 = { class: "field-radiobutton md:mr-1" }
const _hoisted_7 = {
  for: "customer-status-existed",
  class: "ml-2"
}

import { reactive, withDefaults } from "vue";
import RadioButton from "primevue/radiobutton";
import NewCustomer from "./new.vue";
import ExistedCustomer from "./existed.vue";
import { BookingCustomerStatus } from "@/clinic/typings/enums/booking";
import { ICustomer } from "@/clinic/typings";
import { ValidateError } from "async-validator";

type ICustomerField = {
  id: number;
  hasEdit: boolean;
  customerStatus: BookingCustomerStatus;
  customers: ICustomer[];
  errorFields: Record<string, ValidateError[]>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: { default: 0 },
    hasEdit: { type: Boolean, default: false },
    customerStatus: { default: BookingCustomerStatus.existed },
    customers: null,
    errorFields: null
  },
  emits: ["changingCustomerStatus", "changingCustomer", "changingName"],
  setup(__props: any, { emit: emits }) {

const props = __props as { id: number, hasEdit: boolean, customerStatus: BookingCustomerStatus, customers: ICustomer[], errorFields: Record<string, ValidateError[]> };





const formCustomer = reactive({
  status: props.customerStatus,
});

const onChangingCustomer = (customerId: number) => emits("changingCustomer", customerId);

const onChangingCustomerStatus = (newStatus: string) => emits("changingCustomerStatus", newStatus);

const onChangingName = (newName: string) => emits("changingName", newName);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass({ 'disabled-root': __props.hasEdit })
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(RadioButton), {
            inputId: "customer-status-new",
            name: "customer_status",
            modelValue: formCustomer.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formCustomer.status) = $event)),
            value: _unref(BookingCustomerStatus).new,
            required: true,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (onChangingCustomerStatus(_unref(BookingCustomerStatus).new)))
          }, null, 8, ["modelValue", "value"]),
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(BookingCustomerStatus).new), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(RadioButton), {
            inputId: "customer-status-existed",
            name: "customer_status",
            modelValue: formCustomer.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formCustomer.status) = $event)),
            value: _unref(BookingCustomerStatus).existed,
            required: true,
            onChange: _cache[3] || (_cache[3] = ($event: any) => (onChangingCustomerStatus(_unref(BookingCustomerStatus).existed)))
          }, null, 8, ["modelValue", "value"]),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(BookingCustomerStatus).existed), 1)
        ])
      ]),
      (formCustomer.status == _unref(BookingCustomerStatus).new)
        ? (_openBlock(), _createBlock(NewCustomer, {
            key: 0,
            errorFields: __props.errorFields,
            onChangingName: onChangingName
          }, null, 8, ["errorFields"]))
        : (_openBlock(), _createBlock(ExistedCustomer, {
            key: 1,
            id: __props.id,
            customers: __props.customers,
            errorFields: __props.errorFields,
            onChange: onChangingCustomer
          }, null, 8, ["id", "customers", "errorFields"]))
    ], 2)
  ]))
}
}

})